var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Nav',{staticClass:"limit-width"}),_c('router-view',{staticClass:"limit-width"}),(_vm.$router.currentRoute.name !== 'Blog')?_c('Footer',{staticClass:"limit-width"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }